import { useQuery } from "convex/react";
import { api } from "../../api";

// Type definition based on api.ts
interface AppCategory {
  name: string;
  tags: string[];
}

/**
 * Hook to fetch all app categories from Convex
 * Returns the categories array and loading state
 */
export const useAppCategories = () => {
  const categoriesData = useQuery(api.appCategories.list.categories);
  
  const categories: AppCategory[] = categoriesData ?? [];
  const isLoading = categoriesData === undefined;
  
  return { categories, isLoading };
};

/**
 * Utility function to log all categories to console
 * Call this from a component that has access to the categories data
 */
export const logAppCategories = (categories: AppCategory[]) => {
  console.log("=== All App Categories ===");
  console.log(`Total categories: ${categories.length}`);
  console.log("");
  
  categories.forEach((category, index) => {
    console.log(`${index + 1}. ${category.name}`);
    console.log(`   Tags: ${category.tags.length > 0 ? category.tags.join(", ") : "(none)"}`);
  });
  
  console.log("");
  console.log("Category names for appFilter:", categories.map(c => c.name));
  
  return categories;
};

/**
 * Get category names as an array (for use in appFilter keys)
 */
export const getCategoryNames = (categories: AppCategory[]): string[] => {
  return categories.map(c => c.name);
};

/**
 * Check if a category name exists
 */
export const isCategoryValid = (categories: AppCategory[], categoryName: string): boolean => {
  return categories.some(c => c.name === categoryName);
};
